import autosize from 'autosize';

export default function() {
    //Do yo JAHVAHSCRIPT here.

	autosize($('textarea'));

    //search logic
    $('.search-btn-trigger').on('click', function () {
        $('.search-container').slideDown(500);
        $('.search-container input').focus();
        $('body').addClass('overflow-hidden');
    });

    $('.exit-search').on('click', function () {
        $('.search-container').slideUp(500);
        $('body').removeClass('overflow-hidden');
    });
}